import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '@psu-pennstateit-swe/utils/security';
import { catchError, of } from 'rxjs';
import { PermissionsFacade } from '../permissions/permissions.facade';

export const canViewGuard: (permission: string) => CanMatchFn =
  (permission: string): CanMatchFn =>
  () => {
    const currentUser = inject(AuthService).getCurrentUser();
    const permissionMap = inject(PermissionsFacade).permissionMap;
    const router = inject(Router);

    if (currentUser) {
      return permissionMap.get(permission)?.pipe(catchError(() => of(false))) ?? of(false);
    }

    return router.parseUrl('/forbidden');
  };
